module.exports = __webpack_public_path__ + "files/ricai_spiadi_2021.8563ca87c0955568f68139bf5e8a21e1.pdf";